import React from "react";
import { useTranslation } from "react-i18next";
import "./Autenticator.css";

export default function LanguageFlagSwitcher() {
  const { i18n, t } = useTranslation("auth");
  const current = i18n.language?.startsWith("es") ? "es" : "en";
  const next = current === "es" ? "en" : "es";

  const toggle = () => {
    i18n.changeLanguage(next);
  };

  return (
    <div className="auth-lang-switcher">
      <button
        type="button"
        className="lang-btn"
        onClick={toggle}
        title={current === "es" ? "Switch to English" : "Cambiar a Español"}
        aria-label={
          current === "es" ? "Switch to English" : "Cambiar a Español"
        }
      >
        {i18n.language === "es" ? (
          <img
            className="auth-lang-switcher__flag"
            src="https://s.w.org/images/core/emoji/14.0.0/svg/1f1ea-1f1f8.svg"
            alt={t("flagEsAlt")}
            width={25}
            height={25}
          />
        ) : (
          <img
            className="auth-lang-switcher__flag"
            src="https://s.w.org/images/core/emoji/14.0.0/svg/1f1fa-1f1f8.svg"
            alt={t("flagEnAlt")}
            width={25}
            height={25}
          />
        )}
      </button>
    </div>
  );
}
